import moment from "moment";
import React, { useEffect, useState } from "react";
import isEqual from "react-fast-compare";
import { useSelector } from "react-redux";
import GoogleTrend from "../DeepDivetab/GoogleTrend/GoogleTrend";
import { getSimplifiedKeywordForGoogle } from "../../../../redux/constants/commandCenterConstants";
const GoogleTrendsContainerForTwitter = ({}) => {
  const [params, setParams] = useState(null);
  const [iframes, setIframes] = useState([]);
  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );
  const countryStateCityFilters = useSelector(
    (state) => state?.Screens?.screen?.country_state_city_filters
  );
  // working code but not optimized
  // const createDynamicIFrame = (params, displayKeyword, callback) => {
  //   console.log(
  //     "createDynamicIFrame got called : ",
  //     params,
  //     displayKeyword,
  //     callback
  //   );
  //   const arrTrendsData = [
  //     "GEO_MAP",
  //     "RELATED_QUERIES",
  //     "ResponseOFRelatedQueryApi",
  //   ];
  //   const keyword =
  //     displayKeyword === undefined
  //       ? getSimplifiedKeywordForGoogle(params?.searchText)
  //       : getSimplifiedKeywordForGoogle(params?.keyword); // params?.keyword;

  //   let startDate = moment.unix(params?.startDate).format("MMM Do YY");
  //   let endDate = moment.unix(params?.endDate).format("MMM Do YY");

  //   const region = ""; //params?.region;
  //   const tz = params?.timeOffset;

  //   if (
  //     moment
  //       .unix(params.endDate)
  //       .diff(moment.unix(params.startDate), "hours") <=
  //     7 * 24
  //   ) {
  //     startDate = "now";
  //     endDate = "7-d";
  //   } else {
  //     startDate = "today";
  //     endDate = "1-m";
  //   }

  //   const iframes = arrTrendsData.map((data, i) => {
  //     if (i === 2) {
  //       return (
  //         <div className="col-lg-6" key={i}>
  //           <div className="google-list">
  //             <div className="heading">
  //               <span>
  //                 Similar searches -{" "}
  //                 {displayKeyword === undefined ? keyword : displayKeyword}
  //               </span>
  //               <div
  //                 className="embed-subtitle"
  //                 style={{ height: "1.7rem" }}
  //               ></div>
  //             </div>
  //             <ul id="GoogleRelatedQuries"></ul>
  //           </div>
  //         </div>
  //       );
  //     } else {
  //       const urlSource = `https://trends.google.com:443/trends/embed/explore/${data}?req={"comparisonItem":[{"keyword":"${keyword}","geo":"${region}","time":"${startDate} ${endDate}"}],"category":0,"property":""}&tz=${tz}&eq=q=${keyword}&date=${startDate} ${endDate}&geo=${region}&w=500&h=500`;
  //       console.log("urlSource : ", urlSource);
  //       return (
  //         <div
  //           className={data === "GEO_MAP" ? "col-lg-12" : "col-lg-6"}
  //           key={i}
  //         >
  //           <iframe
  //             id={`trends-widget-${i + 1}`}
  //             src={encodeURI(urlSource)}
  //             allowfullscreen={true}
  //             alt="Google Trend"
  //             frameBorder="0"
  //             scrolling="0"
  //             title={`trends-widget-${i + 1}`}
  //             style={{
  //               width: "calc(100% - 2rem)",
  //               height: data === "RELATED_QUERIES" ? "36rem" : "41rem",
  //               margin: "1rem",
  //             }}
  //             className="border-0 border-radius-4"
  //             sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
  //           ></iframe>
  //         </div>
  //       );
  //     }
  //   });

  //   callback(iframes);
  // };
  // useEffect(() => {
  //   console.log("useEffect got called : params : ", params);
  //   if (params) {
  //     createDynamicIFrame(params, params?.keyword, setIframes);
  //   }
  // }, [params]);
  useEffect(() => {
    // for creating params and access deepdive object
    if (deepdive_object) {
      let selectedKeyword = deepdive_object?.deepdive_on?.x_axis?.value?.trim();
      let selectedRegion;
      if (countryStateCityFilters && Array.isArray(countryStateCityFilters)) {
        let selectedCountry = countryStateCityFilters?.find(
          (f) => f?.attribute === "twitter_trend_country"
        );
        selectedRegion =
          selectedCountry?.columns && Array.isArray(selectedCountry?.columns)
            ? selectedCountry?.columns?.[0]?.country_code
            : selectedCountry?.country_code
            ? selectedCountry?.country_code
            : null;
      }
      let params = {
        startDate: deepdive_object?.start_date,
        endDate: deepdive_object?.end_date,
        timeOffset: new Date()?.getTimezoneOffset(),
        keyword: selectedKeyword,
        region: selectedRegion,
      };
      setParams(params);
    }
  }, [deepdive_object]);
  return (
    <>
      {/* <div id="GoogleTrendsContainer" className="row m-0">
        {iframes}
      </div> */}
      <div id="GoogleTrendsContainerForTwitter" className="m-0">
        {params ? (
          <>
            <div className="row m-0">
              <div className={"col-lg-12 p-2"}>
                <GoogleTrend
                  widget_id="twitter_trend_1"
                  type="GEO_MAP"
                  keyword={params?.keyword}
                  region=""
                  params={params}
                  className={""}
                  isTwitterTrend={true}
                />
              </div>
            </div>
            <div className="row m-0">
              <div className={"col-lg-6 p-2"}>
                <GoogleTrend
                  widget_id="twitter_trend_2"
                  type="RELATED_TOPICS"
                  keyword={params?.keyword}
                  region=""
                  params={params}
                  className={""}
                  isTwitterTrend={true}
                />
              </div>
              <div className={"col-lg-6 p-2"}>
                <GoogleTrend
                  widget_id="twitter_trend_2"
                  type="RELATED_QUERIES"
                  keyword={params?.keyword}
                  region=""
                  params={params}
                  className={""}
                  isTwitterTrend={true}
                />
              </div>
              {/* <div className="col-lg-4 p-2">
                <div className="google-list TrendWidget border-0 border-radius-4">
                  <div className="heading">
                    <span>Similar searches - {params?.keyword}</span>
                    <div
                      className="embed-subtitle"
                      style={{ height: "1.7rem" }}
                    ></div>
                  </div>
                  <ul id="GoogleRelatedQuries"></ul>
                </div>
              </div> */}
            </div>
          </>
        ) : (
          <>
            <div className="loader mx-auto" style={{ height: "calc(60rem)" }}>
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default React.memo(GoogleTrendsContainerForTwitter, isEqual);
